import { render } from "./cp_fav.vue?vue&type=template&id=744df85e&scoped=true"
import script from "./cp_fav.vue?vue&type=script&lang=js"
export * from "./cp_fav.vue?vue&type=script&lang=js"

import "./cp_fav.vue?vue&type=style&index=0&id=744df85e&scoped=true&lang=css"

import exportComponent from "E:\\WorkCode\\HZY2026\\Code\\HZY.Student\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-744df85e"]])

export default __exports__